<template>
    <Notification
        variant="neutral"
        icon="InfoCircle"
        padding="l"
        class="passport-examples-notification"
        :tier="2">
        <div>
            {{ t({ key: 'shared.note' }) }}
            {{ t({ key: 'shared.passport_information' }) }}
        </div>
        <ButtonLink class="button" size="m" :onClick="onClick">
            {{ t({ key: 'shared.example' }) }}
        </ButtonLink>
    </Notification>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';
    import { t } from '@shared/helpers/translation';
    import { ModalType } from '@/store/general/types';
    import store from '@/store';
    import Notification from '@ui/components/Notification/Notification.vue';
    import ButtonLink from '@ui/components/Button/ButtonLink.vue';

    export default defineComponent({
        name: 'PassportExamples',
        components: { ButtonLink, Notification },
        methods: { t },
        setup() {
            const onClick = () => {
                store.dispatch('general/setModal', {
                    type: ModalType.PassportExamples,
                });
            };

            return {
                onClick,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'PassportExamples.scss';
</style>
